/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Availability } from '../models/Availability';
import type { AvailabilityApproveDecline } from '../models/AvailabilityApproveDecline';
import type { AvailabilityEmployeeUpdate } from '../models/AvailabilityEmployeeUpdate';
import type { AvailabilityManager } from '../models/AvailabilityManager';
import type { AvailabilityManagerUpdate } from '../models/AvailabilityManagerUpdate';
import type { PaginatedAvailabilityList } from '../models/PaginatedAvailabilityList';
import type { PatchedAvailabilityApproveDecline } from '../models/PatchedAvailabilityApproveDecline';
import type { PatchedAvailabilityEmployeeUpdate } from '../models/PatchedAvailabilityEmployeeUpdate';
import type { PatchedAvailabilityManagerUpdate } from '../models/PatchedAvailabilityManagerUpdate';
import type { PatchedEventDestroy } from '../models/PatchedEventDestroy';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AvailabilityService {
  /**
   * View set for the Availability objects.
   * @returns PaginatedAvailabilityList
   * @throws ApiError
   */
  public static availabilityEmployeeList({
    organisationUid,
    availabilityType,
    availabilityTypeIn,
    dtendGt,
    dtstartLt,
    employmentUid,
    employmentUidIn,
    hasLeaveAllowanceImpact,
    o,
    page,
    pageSize,
    statusIn,
  }: {
    organisationUid: string,
    /**
     * * `available` - Available
     * * `sick` - Sick
     * * `leave` - Leave
     * * `overtime` - Overtime
     */
    availabilityType?: 'available' | 'leave' | 'overtime' | 'sick',
    /**
     * Multiple values may be separated by commas.
     */
    availabilityTypeIn?: Array<string>,
    dtendGt?: string,
    dtstartLt?: string,
    employmentUid?: string,
    /**
     * Multiple values may be separated by commas.
     */
    employmentUidIn?: Array<string>,
    hasLeaveAllowanceImpact?: boolean,
    /**
     * Which field to use when ordering the results.
     */
    o?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    /**
     * Multiple values may be separated by commas.
     */
    statusIn?: Array<string>,
  }): CancelablePromise<PaginatedAvailabilityList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{organisation__uid}/availability/employee',
      path: {
        'organisation__uid': organisationUid,
      },
      query: {
        'availability_type': availabilityType,
        'availability_type__in': availabilityTypeIn,
        'dtend__gt': dtendGt,
        'dtstart__lt': dtstartLt,
        'employment__uid': employmentUid,
        'employment__uid__in': employmentUidIn,
        'has_leave_allowance_impact': hasLeaveAllowanceImpact,
        'o': o,
        'page': page,
        'page_size': pageSize,
        'status__in': statusIn,
      },
    });
  }
  /**
   * View set for the Availability objects.
   * @returns Availability
   * @throws ApiError
   */
  public static availabilityEmployeeCreate({
    organisationUid,
    requestBody,
  }: {
    organisationUid: string,
    requestBody: Availability,
  }): CancelablePromise<Availability> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v5/organisations/{organisation__uid}/availability/employee',
      path: {
        'organisation__uid': organisationUid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Availability objects.
   * @returns Availability
   * @throws ApiError
   */
  public static availabilityEmployeeRetrieve({
    organisationUid,
    uid,
  }: {
    organisationUid: string,
    uid: string,
  }): CancelablePromise<Availability> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{organisation__uid}/availability/employee/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
    });
  }
  /**
   * View set for the Availability objects.
   * @returns AvailabilityEmployeeUpdate
   * @throws ApiError
   */
  public static availabilityEmployeeUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody?: AvailabilityEmployeeUpdate,
  }): CancelablePromise<AvailabilityEmployeeUpdate> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v5/organisations/{organisation__uid}/availability/employee/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Availability objects.
   * @returns AvailabilityEmployeeUpdate
   * @throws ApiError
   */
  public static availabilityEmployeePartialUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody?: PatchedAvailabilityEmployeeUpdate,
  }): CancelablePromise<AvailabilityEmployeeUpdate> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v5/organisations/{organisation__uid}/availability/employee/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Availability objects.
   * @returns AvailabilityManager
   * @throws ApiError
   */
  public static availabilityManagerList({
    organisationUid,
    availabilityType,
    availabilityTypeIn,
    contactUid,
    contactUidIn,
    dtendGt,
    dtstartLt,
    employmentUid,
    employmentUidIn,
    hasLeaveAllowanceImpact,
    o,
    statusIn,
  }: {
    organisationUid: string,
    /**
     * * `available` - Available
     * * `sick` - Sick
     * * `leave` - Leave
     * * `overtime` - Overtime
     */
    availabilityType?: 'available' | 'leave' | 'overtime' | 'sick',
    /**
     * Multiple values may be separated by commas.
     */
    availabilityTypeIn?: Array<string>,
    contactUid?: string,
    /**
     * Multiple values may be separated by commas.
     */
    contactUidIn?: Array<string>,
    dtendGt?: string,
    dtstartLt?: string,
    employmentUid?: string,
    /**
     * Multiple values may be separated by commas.
     */
    employmentUidIn?: Array<string>,
    hasLeaveAllowanceImpact?: boolean,
    /**
     * Which field to use when ordering the results.
     */
    o?: string,
    /**
     * Multiple values may be separated by commas.
     */
    statusIn?: Array<string>,
  }): CancelablePromise<Array<AvailabilityManager>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{organisation__uid}/availability/manager',
      path: {
        'organisation__uid': organisationUid,
      },
      query: {
        'availability_type': availabilityType,
        'availability_type__in': availabilityTypeIn,
        'contact__uid': contactUid,
        'contact__uid__in': contactUidIn,
        'dtend__gt': dtendGt,
        'dtstart__lt': dtstartLt,
        'employment__uid': employmentUid,
        'employment__uid__in': employmentUidIn,
        'has_leave_allowance_impact': hasLeaveAllowanceImpact,
        'o': o,
        'status__in': statusIn,
      },
    });
  }
  /**
   * View set for the Availability objects.
   * @returns AvailabilityManager
   * @throws ApiError
   */
  public static availabilityManagerCreate({
    organisationUid,
    requestBody,
  }: {
    organisationUid: string,
    requestBody: AvailabilityManager,
  }): CancelablePromise<AvailabilityManager> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v5/organisations/{organisation__uid}/availability/manager',
      path: {
        'organisation__uid': organisationUid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Availability objects.
   * @returns AvailabilityManager
   * @throws ApiError
   */
  public static availabilityManagerRetrieve({
    organisationUid,
    uid,
  }: {
    organisationUid: string,
    uid: string,
  }): CancelablePromise<AvailabilityManager> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
    });
  }
  /**
   * View set for the Availability objects.
   * @returns AvailabilityManagerUpdate
   * @throws ApiError
   */
  public static availabilityManagerUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody?: AvailabilityManagerUpdate,
  }): CancelablePromise<AvailabilityManagerUpdate> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Availability objects.
   * @returns AvailabilityManagerUpdate
   * @throws ApiError
   */
  public static availabilityManagerPartialUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody?: PatchedAvailabilityManagerUpdate,
  }): CancelablePromise<AvailabilityManagerUpdate> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Availability objects.
   * @returns AvailabilityApproveDecline
   * @throws ApiError
   */
  public static availabilityManagerApprovePartialUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody?: PatchedAvailabilityApproveDecline,
  }): CancelablePromise<AvailabilityApproveDecline> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}/approve',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Availability objects.
   * @returns AvailabilityApproveDecline
   * @throws ApiError
   */
  public static availabilityManagerCancelPartialUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody?: PatchedAvailabilityApproveDecline,
  }): CancelablePromise<AvailabilityApproveDecline> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}/cancel',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Checks if the Availability is eligible for deletion.
   * @returns any No response body
   * @throws ApiError
   */
  public static availabilityManagerDeletePartialUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody?: PatchedEventDestroy,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}/delete',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Rejects a leave request. This method can only be used by a manager.
   *
   * :param request: the request to process
   * :returns: Response with
   * @returns AvailabilityApproveDecline
   * @throws ApiError
   */
  public static availabilityManagerRejectPartialUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody?: PatchedAvailabilityApproveDecline,
  }): CancelablePromise<AvailabilityApproveDecline> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v5/organisations/{organisation__uid}/availability/manager/{uid}/reject',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
